export default "__VITE_ASSET__rkJWW1xJ__"